'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, Divider, Modal } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgInfo, SvgShare2 } from '@common/icon';
import { cn } from '@core/utils';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { AuthMutation, AuthQueryOptions, TERM_CATEGORY, VERIFICATION_TYPE } from '@/api';
import { DesktopSideAdBanner } from '@/app/_components/ads';
import { CustomLink } from '@/app/_components/CustomLink';
import { BottomSheet } from '@/app/welmarket/_components/BottomSheet';
import { Image } from '@/components/client';
import { IMAGE_PLACEHOLDER, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { PointUsageSection } from './PointUsageSection';
interface ProductDetail {
  thumbnailUrl?: string;
  productName?: string;
  brandName?: string;
  originalPrice?: number;
  brandNotice?: string;
  productType?: string;
}
interface ProductDetailClientProps {
  idx: string;
  product: ProductDetail;
}
export const ProductDetailClient = t0 => {
  const $ = _c(223);
  const {
    idx,
    product
  } = t0;
  const {
    thumbnailUrl,
    productName: t1,
    brandName,
    originalPrice: t2,
    brandNotice,
    productType
  } = product;
  const productName = t1 === undefined ? "" : t1;
  const originalPrice = t2 === undefined ? 0 : t2;
  const isLogin = useAuthStore(_temp);
  const myInfo = useAuthStore(_temp2);
  const setShareLink = useGlobalStore(_temp3);
  const setTermsDrawerType = useGlobalStore(_temp4);
  const router = useCustomRouter();
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const {
    toast,
    toastError
  } = useToast();
  let t3;
  if ($[0] !== idx) {
    t3 = AuthQueryOptions["get:/wello/v2/auth/point-market/order/preview"]({
      query: {
        productIdIdx: idx
      }
    });
    $[0] = idx;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isLogin === true;
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = {
      ...t3,
      enabled: t4,
      select: _temp5
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const previewQuery = useQuery(t5);
  const isAuthResolving = isLogin === undefined;
  const isPreviewLoading = isLogin === true && previewQuery.isLoading;
  const availablePoints = previewQuery.data?.point.availablePoint ?? 0;
  const usedPoints = previewQuery.data?.point.usedPoint ?? originalPrice;
  const leftPoints = availablePoints - usedPoints;
  const isPointsInsufficient = isLogin === true && leftPoints < 0;
  const [isCheckedExp, setIsCheckedExp] = useState(false);
  const [isCheckedPhone, setIsCheckedPhone] = useState(false);
  const [isCheckedMms, setIsCheckedMms] = useState(false);
  const [isCheckedPrivacy, setIsCheckedPrivacy] = useState(false);
  const isAllChecked = isCheckedExp && isCheckedPhone && isCheckedMms && isCheckedPrivacy;
  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = AuthMutation["post:/wello/v2/auth/point-market/order/payments"]();
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== brandName || $[7] !== idx || $[8] !== originalPrice || $[9] !== productName || $[10] !== queryClient || $[11] !== router || $[12] !== toast) {
    t7 = async () => {
      trackGtmEvent(GTM_EVENT_TYPE.USE_POINT, {
        product_name: productName,
        product_brand: brandName ?? "",
        product_value: originalPrice,
        product_id: idx
      });
      await queryClient.invalidateQueries();
      toast({
        message: "\uAD6C\uB9E4\uD558\uC2E0 \uAD50\uD658\uAD8C\uC774 \uBB38\uC790\uB85C \uBC1C\uC1A1\uB418\uC5C8\uC5B4\uC694."
      });
      router.replace(ROUTES.POINT_MARKET_ORDER_COMPLETE.pathname);
    };
    $[6] = brandName;
    $[7] = idx;
    $[8] = originalPrice;
    $[9] = productName;
    $[10] = queryClient;
    $[11] = router;
    $[12] = toast;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== toastError) {
    t8 = error => {
      toastError({
        error
      });
    };
    $[14] = toastError;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = {
      ...t6,
      onSuccess: t7,
      onError: t8
    };
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const {
    mutate: pay,
    isPending: isPaying
  } = useMutation(t9);
  let t10;
  if ($[19] !== pathname) {
    t10 = ROUTES.EASY_CERTIFICATION.withSearchParams({
      searchParams: {
        verification: VERIFICATION_TYPE.PROFILE_UPDATE,
        isNotUseCertificateCache: "Y",
        redirect: pathname ?? ""
      }
    });
    $[19] = pathname;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const verificationHref = t10;
  let t11;
  if ($[21] !== idx || $[22] !== isAuthResolving || $[23] !== isLogin || $[24] !== isPointsInsufficient || $[25] !== isPreviewLoading || $[26] !== myInfo?.cellPhone?.length || $[27] !== pathname || $[28] !== pay || $[29] !== router) {
    t11 = () => {
      if (isAuthResolving || isPreviewLoading) {
        return;
      }
      if (!isLogin) {
        router.push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: pathname ?? ""
          }
        }));
        return;
      }
      if (isPointsInsufficient) {
        return;
      }
      if ((myInfo?.cellPhone?.length ?? 0) < 5) {
        setIsVerifyModalOpen(true);
        return;
      }
      pay({
        body: {
          productIdIdx: idx
        }
      });
    };
    $[21] = idx;
    $[22] = isAuthResolving;
    $[23] = isLogin;
    $[24] = isPointsInsufficient;
    $[25] = isPreviewLoading;
    $[26] = myInfo?.cellPhone?.length;
    $[27] = pathname;
    $[28] = pay;
    $[29] = router;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const handlePaymentClick = t11;
  let t12;
  if ($[31] !== setShareLink) {
    t12 = () => {
      if (typeof window === "undefined") {
        return;
      }
      setShareLink(window.location.href);
    };
    $[31] = setShareLink;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const handleShare = t12;
  const ctaDisabled = isAuthResolving || isPreviewLoading || isLogin === true && (!isAllChecked || isPointsInsufficient || isPaying);
  const ctaLabel = isPointsInsufficient ? "\uD3EC\uC778\uD2B8\uAC00 \uBD80\uC871\uD574\uC694" : "\uACB0\uC81C\uD558\uAE30";
  const safeThumbnail = thumbnailUrl || IMAGE_PLACEHOLDER;
  let t13;
  if ($[33] !== myInfo) {
    t13 = myInfo?.cellPhone ? myInfo.cellPhone.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") : null;
    $[33] = myInfo;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const formattedPhone = t13;
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("grid grid-cols-[660px_480px] justify-between gap-x-60", "mobile-tablet:grid-cols-1 mobile-tablet:gap-x-0");
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== productName || $[37] !== safeThumbnail) {
    t15 = <div className="relative aspect-square w-full overflow-hidden rounded-large mobile-tablet:rounded-none"><Image fill={true} sizes="(max-width: 1279px) 100vw, 660px" src={safeThumbnail} alt={productName} className="object-cover" /></div>;
    $[36] = productName;
    $[37] = safeThumbnail;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== brandName) {
    t16 = brandName ? <div className="flex h-22 w-fit items-center justify-center rounded-pill bg-Gray-200 px-6 py-3"><span className="font-600 text-Gray-600 typo-caption2">{brandName}</span></div> : null;
    $[39] = brandName;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== productName) {
    t17 = <h1 className="font-700 text-Gray-900 typo-h7">{productName}</h1>;
    $[41] = productName;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t16 || $[44] !== t17) {
    t18 = <div className="flex flex-1 flex-col gap-8">{t16}{t17}</div>;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SvgShare2 className="size-full" />;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== handleShare) {
    t20 = <button type="button" aria-label={"\uC0C1\uD488 \uACF5\uC720"} onClick={handleShare} className="size-20 shrink-0 text-Gray-900">{t19}</button>;
    $[47] = handleShare;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t18 || $[50] !== t20) {
    t21 = <div className="flex items-start justify-between gap-12">{t18}{t20}</div>;
    $[49] = t18;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== originalPrice) {
    t22 = originalPrice.toLocaleString();
    $[52] = originalPrice;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t22) {
    t23 = <p className="font-700 text-Gray-700 typo-h5">{t22}P</p>;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t23) {
    t24 = <section className="hidden flex-col gap-16 px-20 mobile-tablet:flex">{t21}{t23}</section>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Divider />;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="flex gap-16"><dt className="flex w-92 items-center gap-4 font-400 text-Gray-600 typo-body4">배송비<SvgInfo className="size-12 text-Gray-500" /></dt><dd className="font-700 text-Gray-900 typo-body4">무료배송</dd></div>;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  let t28;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <section className="hidden px-20 mobile-tablet:block"><dl className="flex flex-col gap-12">{t26}<div className="flex gap-16"><dt className="w-92 font-400 text-Gray-600 typo-body4">배송안내</dt><dd className="font-700 text-Gray-900 typo-body4">구매 후 바로 온라인 발급</dd></div></dl></section>;
    t28 = <Divider />;
    $[61] = t27;
    $[62] = t28;
  } else {
    t27 = $[61];
    t28 = $[62];
  }
  let t29;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품명</dt>;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== productName) {
    t30 = <div className="flex flex-col gap-8">{t29}<dd className="font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{productName}</dd></div>;
    $[64] = productName;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== productType) {
    t31 = productType ? <div className="flex flex-col gap-8"><dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품유형</dt><dd className="font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{productType}</dd></div> : null;
    $[66] = productType;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== brandNotice) {
    t32 = brandNotice ? <div className="flex flex-col gap-8"><dt className="font-600 text-Gray-900 typo-body1 mobile-tablet:typo-body3">상품 정보</dt><dd className="whitespace-pre-wrap font-400 leading-normal text-Gray-600 typo-body3 mobile-tablet:typo-body4">{brandNotice}</dd></div> : null;
    $[68] = brandNotice;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t30 || $[71] !== t31 || $[72] !== t32) {
    t33 = <dl className="flex flex-col gap-28 mobile-tablet:gap-24 mobile-tablet:px-20">{t30}{t31}{t32}</dl>;
    $[70] = t30;
    $[71] = t31;
    $[72] = t32;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Divider />;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== availablePoints || $[76] !== isPointsInsufficient || $[77] !== usedPoints) {
    t35 = <div className="mobile-tablet:hidden"><PointUsageSection availablePoints={availablePoints} usedPoints={usedPoints} isInsufficient={isPointsInsufficient} /></div>;
    $[75] = availablePoints;
    $[76] = isPointsInsufficient;
    $[77] = usedPoints;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Divider className="mobile-tablet:hidden" />;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <h2 className="font-700 text-Gray-900 typo-h6 mobile-tablet:typo-body2">결제 금액</h2>;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <dt className="font-700 text-Gray-900">보유 웰포인트</dt>;
    $[81] = t38;
  } else {
    t38 = $[81];
  }
  let t39;
  if ($[82] !== availablePoints) {
    t39 = availablePoints.toLocaleString();
    $[82] = availablePoints;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== t39) {
    t40 = <div className="flex items-center justify-between">{t38}<dd className="font-700 text-Gray-900">{t39}P</dd></div>;
    $[84] = t39;
    $[85] = t40;
  } else {
    t40 = $[85];
  }
  let t41;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <dt className="font-500 text-Gray-600">상품 금액</dt>;
    $[86] = t41;
  } else {
    t41 = $[86];
  }
  const t42 = usedPoints > 0 && "-";
  let t43;
  if ($[87] !== usedPoints) {
    t43 = usedPoints.toLocaleString();
    $[87] = usedPoints;
    $[88] = t43;
  } else {
    t43 = $[88];
  }
  let t44;
  if ($[89] !== t42 || $[90] !== t43) {
    t44 = <div className="flex items-center justify-between pl-4">{t41}<dd className="font-500 text-Gray-600">{t42}{t43}P</dd></div>;
    $[89] = t42;
    $[90] = t43;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  let t45;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Divider />;
    $[92] = t45;
  } else {
    t45 = $[92];
  }
  let t46;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <dt>잔여 웰포인트</dt>;
    $[93] = t46;
  } else {
    t46 = $[93];
  }
  const t47 = leftPoints < 0 ? "text-R-400" : "text-Gray-900";
  let t48;
  if ($[94] !== t47) {
    t48 = cn(t47);
    $[94] = t47;
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] !== leftPoints) {
    t49 = leftPoints.toLocaleString();
    $[96] = leftPoints;
    $[97] = t49;
  } else {
    t49 = $[97];
  }
  let t50;
  if ($[98] !== t48 || $[99] !== t49) {
    t50 = <div className="flex items-center justify-between font-700 text-Gray-900 typo-h6">{t46}<dd className={t48}>{t49}P</dd></div>;
    $[98] = t48;
    $[99] = t49;
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  let t51;
  if ($[101] !== t40 || $[102] !== t44 || $[103] !== t50) {
    t51 = <section className="flex flex-col gap-16 mobile-tablet:px-20">{t37}<dl className="flex flex-col gap-12 typo-body3">{t40}{t44}{t45}{t50}</dl></section>;
    $[101] = t40;
    $[102] = t44;
    $[103] = t50;
    $[104] = t51;
  } else {
    t51 = $[104];
  }
  const t52 = formattedPhone ? `[${formattedPhone}]` : "[\uD734\uB300\uC804\uD654\uBC88\uD638 \uBCC0\uC218]";
  let t53;
  if ($[105] !== t52) {
    t53 = <span className="font-700 text-O-400">{t52}</span>;
    $[105] = t52;
    $[106] = t53;
  } else {
    t53 = $[106];
  }
  let t54;
  if ($[107] !== verificationHref) {
    t54 = <CustomLink className="underline" href={verificationHref}>여기</CustomLink>;
    $[107] = verificationHref;
    $[108] = t54;
  } else {
    t54 = $[108];
  }
  let t55;
  if ($[109] !== t53 || $[110] !== t54) {
    t55 = <div className="bg-Gray-50 p-20 font-600 leading-normal text-Gray-600 typo-body4 mobile-tablet:mx-20">{t53}로 MMS 메시지를 통해 모바일 쿠폰을 발송합니다. 휴대전화 번호가 변경 되었거나 일치하지 않는 경우{" "}{t54}를 눌러 본인 인증을 다시 진행해 주세요. 인증이 완료되면 해당 번호로 프로필 정보가 자동 업데이트 됩니다.</div>;
    $[109] = t53;
    $[110] = t54;
    $[111] = t55;
  } else {
    t55 = $[111];
  }
  let t56;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <p className="text-Gray-800 typo-body4">웰 포인트상점 모바일쿠폰 발급 이용 약관</p>;
    $[112] = t56;
  } else {
    t56 = $[112];
  }
  let t57;
  let t58;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = checked => {
      setIsCheckedExp(checked);
      setIsCheckedPhone(checked);
      setIsCheckedMms(checked);
      setIsCheckedPrivacy(checked);
    };
    t58 = <strong className="font-600 text-Gray-black typo-body4">약관 전체 동의</strong>;
    $[113] = t57;
    $[114] = t58;
  } else {
    t57 = $[113];
    t58 = $[114];
  }
  let t59;
  if ($[115] !== isAllChecked) {
    t59 = <div className="rounded-xsmall bg-Gray-100 px-14 py-12"><Checkbox className="gap-6 text-Gray-600 typo-caption1" checked={isAllChecked} onCheckedChange={t57}>{t58}</Checkbox></div>;
    $[115] = isAllChecked;
    $[116] = t59;
  } else {
    t59 = $[116];
  }
  let t60;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = checked_0 => setIsCheckedExp(checked_0);
    $[117] = t60;
  } else {
    t60 = $[117];
  }
  let t61;
  if ($[118] !== isCheckedExp) {
    t61 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedExp} onCheckedChange={t60}>만료 기한 연장이 불가능한 모바일 쿠폰임을 확인했습니다.</Checkbox>;
    $[118] = isCheckedExp;
    $[119] = t61;
  } else {
    t61 = $[119];
  }
  let t62;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = checked_1 => setIsCheckedPhone(checked_1);
    $[120] = t62;
  } else {
    t62 = $[120];
  }
  let t63;
  if ($[121] !== isCheckedPhone) {
    t63 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedPhone} onCheckedChange={t62}>전화번호 변경 및 기타 어떤 사유로도 재발급이 불가능합니다.</Checkbox>;
    $[121] = isCheckedPhone;
    $[122] = t63;
  } else {
    t63 = $[122];
  }
  let t64;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = checked_2 => setIsCheckedMms(checked_2);
    $[123] = t64;
  } else {
    t64 = $[123];
  }
  let t65;
  if ($[124] !== isCheckedMms) {
    t65 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedMms} onCheckedChange={t64}>MMS 메시지 수신이 가능한 상태임을 확인했습니다.</Checkbox>;
    $[124] = isCheckedMms;
    $[125] = t65;
  } else {
    t65 = $[125];
  }
  let t66;
  if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = checked_3 => setIsCheckedPrivacy(checked_3);
    $[126] = t66;
  } else {
    t66 = $[126];
  }
  let t67;
  if ($[127] !== setTermsDrawerType) {
    t67 = <div>회원 본인은 위 주문 내용을 확인하였으며 서비스 약관, 개인정보 수집동의, 개인정보 제 3자 제공동의(웰로)에 동의합니다.{" "}<button type="button" className="font-700 text-Gray-black underline typo-caption1" onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        setTermsDrawerType(TERM_CATEGORY.DAOU_PROVIDE_PRIVACY_SELECT);
      }}>보기</button></div>;
    $[127] = setTermsDrawerType;
    $[128] = t67;
  } else {
    t67 = $[128];
  }
  let t68;
  if ($[129] !== isCheckedPrivacy || $[130] !== t67) {
    t68 = <Checkbox className="text-Gray-900 typo-caption1" checked={isCheckedPrivacy} onCheckedChange={t66}>{t67}</Checkbox>;
    $[129] = isCheckedPrivacy;
    $[130] = t67;
    $[131] = t68;
  } else {
    t68 = $[131];
  }
  let t69;
  if ($[132] !== t61 || $[133] !== t63 || $[134] !== t65 || $[135] !== t68) {
    t69 = <div className="mt-4 flex flex-col gap-6">{t61}{t63}{t65}{t68}</div>;
    $[132] = t61;
    $[133] = t63;
    $[134] = t65;
    $[135] = t68;
    $[136] = t69;
  } else {
    t69 = $[136];
  }
  let t70;
  if ($[137] !== t59 || $[138] !== t69) {
    t70 = <section className="flex flex-col gap-12 pb-40 mobile-tablet:px-20">{t56}{t59}{t69}</section>;
    $[137] = t59;
    $[138] = t69;
    $[139] = t70;
  } else {
    t70 = $[139];
  }
  let t71;
  if ($[140] !== t15 || $[141] !== t24 || $[142] !== t33 || $[143] !== t35 || $[144] !== t51 || $[145] !== t55 || $[146] !== t70) {
    t71 = <section className="flex flex-col gap-48 mobile-tablet:gap-24 mobile-tablet:pb-180">{t15}{t24}{t25}{t27}{t28}{t33}{t34}{t35}{t36}{t51}{t55}{t70}</section>;
    $[140] = t15;
    $[141] = t24;
    $[142] = t33;
    $[143] = t35;
    $[144] = t51;
    $[145] = t55;
    $[146] = t70;
    $[147] = t71;
  } else {
    t71 = $[147];
  }
  let t72;
  if ($[148] !== brandName) {
    t72 = brandName ? <div className="self-start bg-Gray-200 px-12 py-4"><span className="font-600 tracking-[-0.28px] text-Gray-600 typo-body4">{brandName}</span></div> : null;
    $[148] = brandName;
    $[149] = t72;
  } else {
    t72 = $[149];
  }
  let t73;
  if ($[150] !== productName) {
    t73 = <h1 className="font-800 leading-[1.2] text-Gray-900 typo-h4">{productName}</h1>;
    $[150] = productName;
    $[151] = t73;
  } else {
    t73 = $[151];
  }
  let t74;
  if ($[152] !== t72 || $[153] !== t73) {
    t74 = <div className="flex flex-1 flex-col gap-8">{t72}{t73}</div>;
    $[152] = t72;
    $[153] = t73;
    $[154] = t74;
  } else {
    t74 = $[154];
  }
  let t75;
  if ($[155] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <SvgShare2 className="size-full" />;
    $[155] = t75;
  } else {
    t75 = $[155];
  }
  let t76;
  if ($[156] !== handleShare) {
    t76 = <button type="button" aria-label={"\uC0C1\uD488 \uACF5\uC720"} onClick={handleShare} className="size-20 shrink-0 text-Gray-900">{t75}</button>;
    $[156] = handleShare;
    $[157] = t76;
  } else {
    t76 = $[157];
  }
  let t77;
  if ($[158] !== t74 || $[159] !== t76) {
    t77 = <div className="flex items-start justify-between gap-12">{t74}{t76}</div>;
    $[158] = t74;
    $[159] = t76;
    $[160] = t77;
  } else {
    t77 = $[160];
  }
  let t78;
  if ($[161] !== originalPrice) {
    t78 = originalPrice.toLocaleString();
    $[161] = originalPrice;
    $[162] = t78;
  } else {
    t78 = $[162];
  }
  let t79;
  if ($[163] !== t78) {
    t79 = <p className="font-700 leading-[1.2] text-Gray-700 typo-h3">{t78}P</p>;
    $[163] = t78;
    $[164] = t79;
  } else {
    t79 = $[164];
  }
  let t80;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = <div className="flex gap-56"><dt className="flex w-92 items-center gap-4 font-500 leading-normal text-Gray-600 typo-body3">배송비<SvgInfo className="size-16 text-Gray-500" /></dt><dd className="font-700 leading-normal text-Gray-900 typo-body3">무료배송</dd></div>;
    $[165] = t80;
  } else {
    t80 = $[165];
  }
  let t81;
  if ($[166] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = <dt className="w-92 font-500 leading-normal text-Gray-600 typo-body3">배송안내</dt>;
    $[166] = t81;
  } else {
    t81 = $[166];
  }
  let t82;
  if ($[167] === Symbol.for("react.memo_cache_sentinel")) {
    t82 = <dl className="flex flex-col gap-16">{t80}<div className="flex gap-56">{t81}<dd className="flex flex-col leading-normal"><span className="font-700 text-Gray-900 typo-body3">구매 후 바로 온라인 발급</span><span className="font-500 text-Gray-700 typo-body3">(식품의 경우 지연 발생 시 1주~2주 소요)</span></dd></div></dl>;
    $[167] = t82;
  } else {
    t82 = $[167];
  }
  let t83;
  if ($[168] !== t77 || $[169] !== t79) {
    t83 = <div className="flex flex-col gap-28">{t77}{t79}{t82}</div>;
    $[168] = t77;
    $[169] = t79;
    $[170] = t83;
  } else {
    t83 = $[170];
  }
  let t84;
  if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = <span className="flex-1 font-700 leading-[1.2] text-Gray-900 typo-h5">상품 금액</span>;
    $[171] = t84;
  } else {
    t84 = $[171];
  }
  let t85;
  if ($[172] !== originalPrice) {
    t85 = originalPrice.toLocaleString();
    $[172] = originalPrice;
    $[173] = t85;
  } else {
    t85 = $[173];
  }
  let t86;
  if ($[174] !== t85) {
    t86 = <div className="flex items-center justify-between gap-16">{t84}<span className="font-800 leading-[1.2] text-Gray-900 typo-h4">{t85}P</span></div>;
    $[174] = t85;
    $[175] = t86;
  } else {
    t86 = $[175];
  }
  let t87;
  if ($[176] === Symbol.for("react.memo_cache_sentinel")) {
    t87 = cn("flex h-68 w-full items-center justify-center bg-O-400 px-24 py-8 font-700 text-Gray-white transition-colors typo-h6", "disabled:bg-Gray-300 disabled:text-Gray-500");
    $[176] = t87;
  } else {
    t87 = $[176];
  }
  let t88;
  if ($[177] !== ctaDisabled || $[178] !== ctaLabel || $[179] !== handlePaymentClick) {
    t88 = <button type="button" disabled={ctaDisabled} onClick={handlePaymentClick} className={t87}>{ctaLabel}</button>;
    $[177] = ctaDisabled;
    $[178] = ctaLabel;
    $[179] = handlePaymentClick;
    $[180] = t88;
  } else {
    t88 = $[180];
  }
  let t89;
  if ($[181] !== t86 || $[182] !== t88) {
    t89 = <div className="flex flex-col gap-20">{t86}{t88}</div>;
    $[181] = t86;
    $[182] = t88;
    $[183] = t89;
  } else {
    t89 = $[183];
  }
  let t90;
  if ($[184] !== t83 || $[185] !== t89) {
    t90 = <aside className="py-32"><div className="flex flex-col gap-40">{t83}{t89}</div></aside>;
    $[184] = t83;
    $[185] = t89;
    $[186] = t90;
  } else {
    t90 = $[186];
  }
  let t91;
  if ($[187] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <DesktopSideAdBanner />;
    $[187] = t91;
  } else {
    t91 = $[187];
  }
  let t92;
  if ($[188] !== t90) {
    t92 = <div className="flex flex-col gap-40 mobile-tablet:hidden">{t90}{t91}</div>;
    $[188] = t90;
    $[189] = t92;
  } else {
    t92 = $[189];
  }
  let t93;
  if ($[190] !== t71 || $[191] !== t92) {
    t93 = <div className={t14}>{t71}{t92}</div>;
    $[190] = t71;
    $[191] = t92;
    $[192] = t93;
  } else {
    t93 = $[192];
  }
  let t94;
  if ($[193] === Symbol.for("react.memo_cache_sentinel")) {
    t94 = <p className="font-700 typo-caption1"><span className="text-Gray-white">이 상품은</span><span className="text-O-400"> 웰포인트로만 </span><span className="text-Gray-white">구매가 가능해요!</span></p>;
    $[193] = t94;
  } else {
    t94 = $[193];
  }
  let t95;
  if ($[194] === Symbol.for("react.memo_cache_sentinel")) {
    t95 = <span className="font-700 text-Gray-900 typo-body3">상품 금액</span>;
    $[194] = t95;
  } else {
    t95 = $[194];
  }
  let t96;
  if ($[195] !== originalPrice) {
    t96 = originalPrice.toLocaleString();
    $[195] = originalPrice;
    $[196] = t96;
  } else {
    t96 = $[196];
  }
  let t97;
  if ($[197] !== t96) {
    t97 = <div className="flex items-center justify-between py-8">{t95}<span className="font-700 text-Gray-black typo-body1">{t96}P</span></div>;
    $[197] = t96;
    $[198] = t97;
  } else {
    t97 = $[198];
  }
  let t98;
  if ($[199] === Symbol.for("react.memo_cache_sentinel")) {
    t98 = cn("flex h-56 w-full items-center justify-center bg-O-400 font-700 text-Gray-white typo-body3", "disabled:bg-Gray-300 disabled:text-Gray-500");
    $[199] = t98;
  } else {
    t98 = $[199];
  }
  let t99;
  if ($[200] !== ctaDisabled || $[201] !== ctaLabel || $[202] !== handlePaymentClick) {
    t99 = <button type="button" disabled={ctaDisabled} onClick={handlePaymentClick} className={t98}>{ctaLabel}</button>;
    $[200] = ctaDisabled;
    $[201] = ctaLabel;
    $[202] = handlePaymentClick;
    $[203] = t99;
  } else {
    t99 = $[203];
  }
  let t100;
  if ($[204] !== t97 || $[205] !== t99) {
    t100 = <BottomSheet toast={t94}><div className="flex flex-col gap-12">{t97}{t99}</div></BottomSheet>;
    $[204] = t97;
    $[205] = t99;
    $[206] = t100;
  } else {
    t100 = $[206];
  }
  let t101;
  if ($[207] === Symbol.for("react.memo_cache_sentinel")) {
    t101 = () => setIsVerifyModalOpen(false);
    $[207] = t101;
  } else {
    t101 = $[207];
  }
  let t102;
  let t103;
  if ($[208] === Symbol.for("react.memo_cache_sentinel")) {
    t102 = <span className="w-full text-center mobile:typo-body1">모바일 쿠폰 발송을 위해<br />본인인증이 필요합니다</span>;
    t103 = <span className="inline-block w-full text-center">계속 하시겠습니까?</span>;
    $[208] = t102;
    $[209] = t103;
  } else {
    t102 = $[208];
    t103 = $[209];
  }
  let t104;
  if ($[210] !== router || $[211] !== verificationHref) {
    t104 = <Button theme="primary-fill" dimensions="H48" className="flex-1" onClick={() => {
      setIsVerifyModalOpen(false);
      router.push(verificationHref);
    }}>확인</Button>;
    $[210] = router;
    $[211] = verificationHref;
    $[212] = t104;
  } else {
    t104 = $[212];
  }
  let t105;
  if ($[213] === Symbol.for("react.memo_cache_sentinel")) {
    t105 = <Button theme="sub-line" dimensions="H48" className="flex-1" onClick={() => setIsVerifyModalOpen(false)}>취소</Button>;
    $[213] = t105;
  } else {
    t105 = $[213];
  }
  let t106;
  if ($[214] !== t104) {
    t106 = <div className="flex items-center gap-12">{t104}{t105}</div>;
    $[214] = t104;
    $[215] = t106;
  } else {
    t106 = $[215];
  }
  let t107;
  if ($[216] !== isVerifyModalOpen || $[217] !== t106) {
    t107 = <Modal opened={isVerifyModalOpen} onClose={t101} header={t102} description={t103} buttonFooter={t106} />;
    $[216] = isVerifyModalOpen;
    $[217] = t106;
    $[218] = t107;
  } else {
    t107 = $[218];
  }
  let t108;
  if ($[219] !== t100 || $[220] !== t107 || $[221] !== t93) {
    t108 = <article className="mx-auto w-full max-w-root pt-100 mobile-tablet:pt-0">{t93}{t100}{t107}</article>;
    $[219] = t100;
    $[220] = t107;
    $[221] = t93;
    $[222] = t108;
  } else {
    t108 = $[222];
  }
  return t108;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return state_0.myInfo;
}
function _temp3(state_1) {
  return state_1.setShareLink;
}
function _temp4(state_2) {
  return state_2.setTermsDrawerType;
}
function _temp5(t0) {
  const {
    context
  } = t0;
  return context;
}